import * as React from 'react';
import { Modal, Button, Table, FormGroup } from 'react-bootstrap';
import FormSelect from '../../components/common/FormSelect';
import { Translate } from '../../shared/LanguageService';
import { IAgreement, IPhotographer } from './Entities';

interface IProps {
    agreement: IAgreement;
    agreements: IAgreement[];
    photographers: IPhotographer[];
    close: (agreement: IAgreement) => void;
    deleteAgreement: (id: number) => void;
    onAgreementUpdate: (photographerId: number, agreementId: number) => void;
}

const AgreementsDeleteModal = (props: IProps) => {
    let photographerUsingAgreement =
        props.photographers &&
        props.agreement &&
        props.photographers.some((x) => x.agreementId === props.agreement.id);

    return (
        <Modal
            show={true}
            onHide={() => props.close(props.agreement)}
            onKeyPress={(target) => {
                if (target.charCode === 13) {
                    props.close(props.agreement);
                }
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {Translate('agreements/page/delete/modal/title')}:{' '}
                    {props.agreement && props.agreement.name ? props.agreement.name : ''}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {photographerUsingAgreement && (
                    <p>{Translate('agreements/page/delete/modal/agreement-used')}</p>
                )}
                {!photographerUsingAgreement && (
                    <p>{Translate('agreements/page/delete/modal/agreement-not-used')}</p>
                )}
                {props.agreement && props.photographers && props.photographers.length > 0 && (
                    <PhotographersList
                        photographers={props.photographers}
                        agreementId={props.agreement.id}
                        agreements={props.agreements}
                        onAgreementUpdate={props.onAgreementUpdate}
                    />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => props.close(props.agreement)}>
                    {Translate('agreements/page/delete/modal/close-button')}
                </Button>
                {props.agreement && (
                    <Button
                        bsStyle="danger"
                        disabled={photographerUsingAgreement}
                        onClick={() => props.deleteAgreement(props.agreement.id)}
                    >
                        {Translate('agreements/page/delete/modal/remove-button')}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

interface PhotographerListProps {
    photographers: IPhotographer[];
    agreementId: number;
    agreements: IAgreement[];
    onAgreementUpdate: (photographerId: number, agreementId: number) => void;
}

const PhotographersList = (props: PhotographerListProps) => {
    return (
        <Table hover responsive>
            <thead>
                <tr>
                    <th>{Translate('agreements/page/delete/modal/photograher-header')}</th>
                    <th>{Translate('agreements/page/delete/modal/agreement-header')}</th>
                </tr>
            </thead>
            <tbody>
                {props.photographers.map((photographer, i) => (
                    <tr key={`agreement-list-${i}`}>
                        <td>{photographer.name}</td>
                        <td>
                            <FormGroup>
                                <FormSelect
                                    value={`${photographer.agreementId}`}
                                    onChange={(e: any) =>
                                        props.onAgreementUpdate(photographer.id, e.target.value)
                                    }
                                >
                                    <option value="-1" disabled={photographer.bookable}>
                                        {Translate(
                                            'agreements/page/delete/modal/no-agreement-option'
                                        )}
                                    </option>
                                    {props.agreements.map((agreement, i) => (
                                        <option
                                            key={`agreement-option-${i}`}
                                            value={`${agreement.id}`}
                                            disabled={agreement.id === props.agreementId}
                                        >
                                            {agreement.name}
                                        </option>
                                    ))}
                                </FormSelect>
                            </FormGroup>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default AgreementsDeleteModal;
